import React from 'react';
import styled from 'styled-components';
import style from './MiddleInfoMessage.style';

const MiddleInfoMessage = ({ message, className, noposition, ...rest }) => (
    <div noposition={noposition} className={className} {...rest}>
        <span>{message}</span>
    </div>
);

export default styled(MiddleInfoMessage)`
    ${style};
`;
